export enum SupportedLanguages {
  EN = 'en',
  DE = 'de',
  CS = 'cs',
  ES = 'es',
  NL = 'nl',
  PT = 'pt',
  FR = 'fr',
}

export const fallbackLng = SupportedLanguages.EN;
export const languages = [
  SupportedLanguages.EN,
  SupportedLanguages.DE,
  SupportedLanguages.CS,
  SupportedLanguages.ES,
  SupportedLanguages.NL,
  SupportedLanguages.PT,
  SupportedLanguages.FR,
];

export const languageFallbacks = {
  'de-*': SupportedLanguages.DE,
  'en-*': SupportedLanguages.EN,
  'pt-*': SupportedLanguages.PT,
  'cs-*': SupportedLanguages.CS,
  'nl-*': SupportedLanguages.NL,
  'es-*': SupportedLanguages.ES,
  'fr-*': SupportedLanguages.FR,
};

export const defaultNS = 'translation';
export const i18nCookieName = 'NEXT_LOCALE';
